<template>
<div>
  Tags: <v-icon small>tag</v-icon>
  <template v-for='tag in appointment.tags' >
    <v-chip
      v-if='successfullyDeleted.indexOf(tag) === -1'
      @input='remove(tag)'
      :key='tag'
      :close='deleteable && tagBeingDeleted === null'
      small dark
      color='primary' >
      <v-progress-circular
        v-if='tag === tagBeingDeleted'
        indeterminate size=12 width="1" class='mr-2' >
      </v-progress-circular>
      {{tag}}
    </v-chip>
  </template>
  <v-chip outline outlined color='primary' @click='launchAppointmentTags({appointmentIds: [appointment.id], touch: Math.random() })' small >
    <v-icon>add</v-icon>
    {{ $t('buttons.add') }}
  </v-chip>
</div>
</template>

<script>
export default {
  name: 'TagList',
  props: {
    appointment: {
      type: Object,
      required: true
    },
    deleteable: { type: Boolean, default: false }
  },
  data () {
    return {
      tagBeingDeleted: null,
      successfullyDeleted: [],
      reqId: 'tag-delete-request'
    }
  },
  computed: {
    deleteRequest () {
      return this.$store.getters.getRequestById(this.reqId, true)
    },
    deleteRequestStatus () {
      return this.deleteRequest.status
    }
  },
  watch: {
    deleteRequestStatus () {
      if (this.deleteRequestStatus === 200) {
        this.successfullyDeleted.push(this.tagBeingDeleted)
        this.tagBeingDeleted = null
      }
    }
  },
  methods: {
    remove (tag) {
      this.tagBeingDeleted = tag
      let data = {
        appointments: this.appointment.id.toString(),
        tags: tag,
        action: 'delete'
      }
      this.$appointmentguru
        .resource('appointment.tags')
        .id(this.reqId)
        .create(data)
    }
  },
  i18n: {
    messages: {
      en: {
        buttons: {
          add: 'Add tags'
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// TagList.vue?1fe54e49